import { s as subscribe } from "../../../chunks/utils.js";
import { c as create_ssr_component, v as validate_component } from "../../../chunks/ssr.js";
import { u as user } from "../../../chunks/auth.js";
import "../../../chunks/client.js";
const Alert = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  let { title = "" } = $$props;
  let { content = "" } = $$props;
  if ($$props.title === void 0 && $$bindings.title && title !== void 0) $$bindings.title(title);
  if ($$props.content === void 0 && $$bindings.content && content !== void 0) $$bindings.content(content);
  return `<div class="flex items-center p-4 mb-4 text-sm text-blue-800 rounded-lg bg-blue-50 " role="alert"><svg class="flex-shrink-0 inline w-4 h-4 mr-3" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 20"><path d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5ZM9.5 4a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3ZM12 15H8a1 1 0 0 1 0-2h1v-3H8a1 1 0 0 1 0-2h2a1 1 0 0 1 1 1v4h1a1 1 0 0 1 0 2Z"></path></svg> <span class="sr-only" data-svelte-h="svelte-qvicv7">Info</span> <div><span class="font-medium"><!-- HTML_TAG_START -->${title}<!-- HTML_TAG_END --></span> <!-- HTML_TAG_START -->${content}<!-- HTML_TAG_END --></div></div>`;
});
const Page = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  let $$unsubscribe_user;
  $$unsubscribe_user = subscribe(user, (value) => value);
  $$unsubscribe_user();
  return `<h2 class="text-coolGray-700 text-lg" data-svelte-h="svelte-myhjaf">Aktuelle Projekte</h2> ${validate_component(Alert, "Alert").$$render($$result, { title: "Keine laufenden Projekte" }, {}, {})} <h2 class="mt-5 text-coolGray-700 text-lg" data-svelte-h="svelte-ac8r35">Kommende Projekte</h2> ${validate_component(Alert, "Alert").$$render(
    $$result,
    {
      title: "Nichts in der Pipeline!",
      content: '<a class="underline" href="/create/project">Neue Projektanfrage</a>'
    },
    {},
    {}
  )}`;
});
export {
  Page as default
};
//# sourceMappingURL=_page.svelte.js.map
